import React, { Component } from "react"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import { Link } from "react-router-dom"
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import "../../assets/scss/datatables.scss"
import { BaseUrl } from "../../helpers/Baseurl"

import SweetAlert from "react-bootstrap-sweetalert";

import default_img from '../../assets/images/noimg.jpeg'


class Customers extends Component {
  constructor(props) {
    super(props)
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 10, 'read' )){
      this.props.history.push('/dashboard')
    }
    this.state = {
      customers: [],
      user_id: "",
      breadcrumbItems: [
          { title : "Planmans", link : "/dashboard" },
          { title : "Users", link : "#" }
          
      ]
    }

    this.handleDelete = this.handleDelete.bind(this)

  }
  

  async componentDidMount() {
 
    this.loadData();
  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/dashboard')
  }

  async loadData(){
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
  };

  await fetch(`${BaseUrl}/api/accounts/users/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              this.setState({ customers: data  })
          },
          (error) => {
              console.log(error, 'error--------------')
             
          }
      ) 
  }

  handleDelete = id => {
    const requestOptions = {
      method: 'DELETE',
    };

    fetch(`${BaseUrl}/api/accounts/users/${id}/`,requestOptions)
    .then(res => 
            {if(res.status >=400 ){
              toastr.error("Something Went Wrong", "")

            }
            else{
                 this.loadData()
                 this.setState({
                  user_id:"",
                  success_confirm: true,
                  alert_confirm : false,
                  dynamic_title: "Deleted!",
                  dynamic_description: "User has been deleted."
                  })
                }    
            }
          )
  }

  render() {
    
    //get Customets
    const { customers } = this.state
   
   
    // Columns
    const EcommerceCustomerColumns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
        formatter: (cellContent, row) => (
          `U-${row.id+100}`    
        )
      },
      {
        dataField: "images",
        text: "Image",
        isDummyField: true,
        formatter: (cellContent, row) => (
          row.image === null?

         <img className="rounded avatar-sm" src={default_img} alt="Header Avatar" /> :
         <img className="rounded avatar-sm" src={row.image} alt="Header Avatar" />

          )

      },
      {
        dataField: "first_name",
        text: "Username",
        sort: true,
        formatter: (cellContent, row) => (
          <>
            <p className="mb-0">{`${row.first_name} ${row.last_name}`}</p>
          </>
        ),
      },
      {
        text: "Email",
        dataField: "email",
        sort: true,
        formatter: (cellContent, row) => (
          <>
            <p className="mb-0">{row.email}</p>
          </>
        ),
      },
      {
        dataField: "role",
        text: "Role",
        isDummyField: true,
        formatter: (cellContent, row) => (
          row.is_superuser?"Manage All": row.role===0?"Manage Itinerary":"Manage Payments"
          )

      },
      {
        dataField: "menu",
        isDummyField: true,
        text: "Action",
        formatter: (cellContent, row) => 
          { if (row.is_superuser){
            return (
           "")
          }else{
            return (
              <>
              {has_Permission(this.obj.user, 10, 'edit' )?
              <Link  to={`/user-detail/${row.id}`} className="me-3 text-secondary"><i className="mdi mdi-eye font-size-18"></i></Link>
              :null}
              {has_Permission(this.obj.user, 10, 'delete' )?
              <Link to="#" onClick={ () => this.setState({ alert_confirm: true, user_id:row.id })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
              :null}
              </>)
          }
        }
      },
    ]
    
    //pagination customization
    const pageOptions = {
      sizePerPage: 10,
      totalSize: customers.length, // replace later with size(customers),
      custom: true,
    }

    const defaultSorted = [{
      dataField: 'id',
      order: 'desc'
    }];

    const { SearchBar } = Search

    return (
      <React.Fragment>

        <div className="page-content">
          
          <Container fluid>
          <Breadcrumbs title="Users" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField='id'
                      data={customers}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField='id'
                          columns={EcommerceCustomerColumns}
                          data={customers}
                          bootstrap4
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row>
                                <Col sm="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="8">
                                  <div className="text-sm-end">
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded mb-2 me-2"
                                      onClick={() => this.props.history.push("/add-user")}

                                    >
                                      <i className="mdi mdi-plus me-1" />{" "}
                                      New User
                                    </Button>
                                  </div>
                                </Col>
                              </Row>

                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField={"id"}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-nowrap"
                                  }
                                  headerWrapperClasses={"thead-light"}
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                />

                              </div>
                              <div className="pagination pagination-rounded justify-content-end mb-2">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        {this.state.alert_confirm ? (
                            <SweetAlert
                            title="Are you sure?"
                            warning
                            showCancel
                            confirmBtnBsStyle="success"
                            cancelBtnBsStyle="danger"
                            onConfirm={() => this.handleDelete(this.state.user_id)}
                            onCancel={() =>
                                this.setState({
                                    alert_confirm: false,
                                    user_id:"",

                                })
                            }
                            >
                            You won't be able to revert this!
                            </SweetAlert>
                        ) : null}

                        {this.state.success_confirm ? (
                      <SweetAlert
                      success
                      title={this.state.dynamic_title}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                      >
                          {this.state.dynamic_description}
                      </SweetAlert>
                  )
                  : null
              }
      </React.Fragment>
    )
  }
}

export default Customers